import { app } from '../../../../../app';
import { Controller } from './assign-groups.controller';

app.component('companyManageApplicationUsersAssignGroups', {
    bindings: {
        application: '<',
        companyId: '<',
        groups: '<',
    },
    controller: Controller,
    templateUrl: require('./assign-groups.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/assign-groups/assign-groups.component.js